export default __webpack_public_path__ + "static/media/pagination-2.f38a74a6.svg";